var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28516 17.1423V11.9994C4.28516 9.95349 5.09791 7.99133 6.54462 6.54462C7.99133 5.09791 9.95349 4.28516 11.9994 4.28516C14.0454 4.28516 16.0076 5.09791 17.4543 6.54462C18.901 7.99133 19.7137 9.95349 19.7137 11.9994V17.1423M19.7137 17.9994C19.7137 18.4541 19.5331 18.8901 19.2116 19.2116C18.8901 19.5331 18.4541 19.7137 17.9994 19.7137H17.1423C16.6876 19.7137 16.2516 19.5331 15.9301 19.2116C15.6086 18.8901 15.428 18.4541 15.428 17.9994V15.428C15.428 14.9734 15.6086 14.5373 15.9301 14.2158C16.2516 13.8943 16.6876 13.7137 17.1423 13.7137H19.7137V17.9994ZM4.28516 17.9994C4.28516 18.4541 4.46577 18.8901 4.78726 19.2116C5.10875 19.5331 5.54479 19.7137 5.99944 19.7137H6.85659C7.31124 19.7137 7.74728 19.5331 8.06877 19.2116C8.39026 18.8901 8.57087 18.4541 8.57087 17.9994V15.428C8.57087 14.9734 8.39026 14.5373 8.06877 14.2158C7.74728 13.8943 7.31124 13.7137 6.85659 13.7137H4.28516V17.9994Z",
    stroke: "#8B9299",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.e90e446931cccb42d50e2a9f375be13b.svg";
export { ForwardRef as ReactComponent };